<template>
  <nc-app />
</template>
